import Vue from 'vue'
import router from '@router'
import store from '@state/store'
import VueLazyload from 'vue-lazyload'
import Scrollspy from 'vue2-scrollspy'

/* import bootstrap for vue */
import { BootstrapVue, IconsPlugin, SkeletonPlugin } from 'bootstrap-vue'
import VueSocialSharing from 'vue-social-sharing'
import VueSecureHTML from 'vue-html-secure'
/* vue translation plugin */
import i18n from './plugins/i18n'
/* import app */
import App from './app.vue'
/* Globally register all `_base`-prefixed components */
import '@components/_globals'

Vue.use(VueSecureHTML)
// Install BootstrapVue
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(SkeletonPlugin)
Vue.use(Scrollspy)
Vue.use(VueSocialSharing)

/* vue lazy load */
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('@assets/images/error.png'),
  // loading: require('@assets/images/default.png'),
  attempt: 1,
  lazyComponent: true,
  filter: {
    progressive(listener, options) {
      const isCDN = /qiniudn.com/
      if (isCDN.test(listener.src)) {
        listener.el.setAttribute('lazy-progressive', 'true')
        listener.loading = listener.src + '?imageView2/1/w/10/h/10'
      }
    },
    webp(listener, options) {
      if (!options.supportWebp) return
      const isCDN = /qiniudn.com/
      if (isCDN.test(listener.src)) {
        listener.src += '?imageView2/2/format/webp'
      }
    },
  },
})

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.mixin({
  methods: {
    /**
     *
     * @param params params object
     * @param additional_param additional param
     * @param type type for attribute or taxonomy searching. default: attribute
     * @param addArray add [] in the end of type. ex: attribute[cat][]
     */
    generateParams: function(
      params,
      additional_param = {},
      type = 'attribute',
      addArray = true
    ) {
      if (Object.keys(additional_param).length > 0) {
        Object.keys(additional_param).forEach((each) => {
          // attribute[tanggal_ditetapkan][]
          params[each] = additional_param[each]
        })
      }
      let emptyArr
      if (addArray === true) {
        emptyArr = '[]'
      } else {
        emptyArr = ''
      }

      var attr = ``
      params = Object.keys(params)
        .map(function(key) {
          if (key === type && Object.keys(params).length > 0) {
            // first loop the 'params'
            Object.keys(params[key]).forEach((each1) => {
              // then we loop the other 'params' so we could get other attribute
              attr += `${type}[${each1}]${emptyArr}=${params[key][each1]}`
              attr += '&'
            })

            return attr.slice(0, -1)
          } else {
            return key + '=' + params[key]
          }
        })
        .join('&')
      return params
    },

    scrollToTargetAdjusted: function(elId) {
      const element = document.getElementById(elId)
      const offset = 150
      const bodyRect = document.body.getBoundingClientRect().top
      const elementRect = element.getBoundingClientRect().top
      const elementPosition = elementRect - bodyRect
      const offsetPosition = elementPosition - offset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      })
    },
  },
})

const app = new Vue({
  i18n,
  router,
  store,
  data() {
    return {
      lang: this.$i18n.locale,
    }
  },
  watch: {
    lang: function(lang) {
      this.$i18n.locale = lang
    },
  },
  render: (h) => h(App),
}).$mount('#app')

global.app = app

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
